var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextTalentou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_36_1",
    "data-name": "Component 36 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2044",
    "data-name": "Rectangle 2044",
    width: 14.002,
    height: 14,
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_490",
    "data-name": "Ellipse 490",
    fill: "rgba(255,0,0,0.1)",
    stroke: "red",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12753",
    "data-name": "Group 12753",
    transform: "translate(6.999 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12752",
    "data-name": "Group 12752",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12693",
    "data-name": "Path 12693",
    d: "M12.437,1.571H7.793V12.436h.2c.495.011.993,0,1.486.039a.726.726,0,0,1,.625.833A.782.782,0,0,1,9.4,14c-1.609,0-3.219.006-4.829-.005a.69.69,0,0,1-.632-.489.725.725,0,0,1,.1-.746.788.788,0,0,1,.7-.322c.485,0,.971,0,1.468,0V1.576H1.578c0,.035-.01.08-.01.126,0,.456.006.912,0,1.367A.8.8,0,0,1,.729,3.9.752.752,0,0,1,0,3.158C0,2.344.013,1.53,0,.716A.8.8,0,0,1,.714,0H13.123A.8.8,0,0,1,14,.868c0,.729.005,1.458,0,2.187a.792.792,0,0,1-.569.807.77.77,0,0,1-.988-.7c-.011-.468,0-.936,0-1.4V1.571",
    fill: "red"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextTalentou);
export default __webpack_public_path__ + "static/media/Text - Talentou.bc55425d88c986006d7de70297c2ee03.svg";
export { ForwardRef as ReactComponent };